<template>
	<v-dialog v-model="dialog" :width="is_col ? 1000 : 600">
		<v-card outlined>
			<v-card-title				
				class="justify-center body-2 pa-1 secondary "
			>
				<v-icon small color="primary">mdi-calendar</v-icon>
				<span v-text="$ml.get('date')"></span>
				: {{info_to_show.createdAt}}
			</v-card-title>
			<v-card-text>
				<v-row 
					no-gutters
				>
					<v-col :md="is_col ? 6 : 12">
						<show_data_info
							v-if="info_to_show"
							:info_show="info_to_show"
						></show_data_info>
					</v-col>
					<v-col md="6" v-show="is_col">
						<video width="100%" height="100%" controls >
						  <source :src="`${$URL}/${info_to_show.vid_path_path}`" type="video/mp4">
						  <source :src="`${$URL}/${info_to_show.vid_path_path}`" type="video/ogg`">	 
						</video>
					</v-col>
				</v-row>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					small
					color="error"
					v-text="$ml.get('close')"
					@click="dialog=false"
				></v-btn>
			</v-card-actions>
		</v-card>
		<audio  autoplay v-if="dialog && is_alertgun_active && is_sound">
			<source src="@/assets/alert_29.mp3" type="audio/mpeg">
			<!-- <source src="@/assets/alert_29.ogg" type="audio/ogg"> -->
			Your browser does not support the audio element.
		</audio>
	</v-dialog>
</template>
<script>
import show_data_info from '@/components/gun/show_data_info.vue'
	export default{
		name: 'show_data_safe_zone',
		components: {
			show_data_info
		}, // components
		props: ['info_to_show', 'is_from'],
		data: () => ({			
			dialog: false,
			is_col: false,
			is_sound: false,
			is_alertgun_active: false,
		}), // data
		created(){
			console.log(this.info_to_show, 'info before show sz');
			if(this.info_to_show){
				// this.dialog=true;
				if (this.info_to_show.vid_path_path) {
					this.is_col=true;
				}
				if (this.is_from=='alert') {					
					if (this.info_to_show.is_alertgun) {
						this.is_alertgun_active=true;
					}
				}
				
				
				// console.log(this.info_to_show, 'info to show');
				if (localStorage.getItem('alert_sound_status')) {
					this.is_sound=JSON.parse(localStorage.getItem('alert_sound_status'));					
				}
				this.render_category();
			}
		}, // created
		
		watch:{
			dialog(v){
				if (!v) {
					this.$emit('close', null);
					this.$emit('close_modal', false);
				}
			},// dialog
		
		}, // watch

		methods:{
			info_format(){

			}, // info format
			
			render_category(){
				let alert_sounds=[], 
					category_to_search='', 
					sound_active=false, 
					pop_up_active=false;

				if (this.info_to_show) {
					category_to_search=this.info_to_show.category;
				}
				if (localStorage.getItem('alert_sounds_setting')) {
					alert_sounds=JSON.parse(localStorage.getItem('alert_sounds_setting'));
				}
				for (var i = 0; i < alert_sounds.length; i++) {
					if(alert_sounds[i].name==category_to_search){
						if (typeof alert_sounds[i].isSound === 'boolean') {
							sound_active=alert_sounds[i].isSound;
						}						
						if (typeof alert_sounds[i].isSound === 'string') {
							if (parseInt(alert_sounds[i].isSound)==1) {
								sound_active=true;
							}else{									
								sound_active=false;
							}
						}
						if (typeof alert_sounds[i].isPopup === 'boolean') {
							pop_up_active=alert_sounds[i].isPopup;
						}
						if (typeof alert_sounds[i].isPopup === 'string') {
							if (parseInt(alert_sounds[i].isPopup)==1) {
								pop_up_active=true;

							}else{
								pop_up_active=false;
							}
						}
					}
				}
				console.log(sound_active, pop_up_active, alert_sounds, 'is active alert sz ');
				this.is_sound=sound_active;
				this.dialog=pop_up_active;
				
			}, // render category
		}, // methods

	};
</script>